<template>
  <div>
    <!-- 核查商品跟进-->
    <baseBreadcrumb :page="$t('message.checkCommodityFollowUp')" :menu="$t('message.inspectionOfGoods')" />
    <section>
      <div class="header">
        <div class="headerContainer">
          <div class="tabs">
            <el-tabs v-model="datas.status" type="card" @tab-click="search">
              <!-- 待发货 -->
              <el-tab-pane :label="$t('message.toHeenShipped')" name="3"></el-tab-pane>
              <!-- 已发货 -->
              <el-tab-pane :label="$t('message.hasHeenShipped')" name="30"></el-tab-pane>
              <!-- 已签收- -->
              <el-tab-pane :label="$t('message.received')" name="32"></el-tab-pane>
              <!--核查中  -->
              <el-tab-pane :label="$t('message.underCheck')" name="40"></el-tab-pane>
              <!--检品中  -->
              <el-tab-pane :label="$t('message.jianpinCenter')" name="50,60"></el-tab-pane>
              <!--检品完了  -->
              <el-tab-pane :label="$t('message.finishedGoods')" name="70"></el-tab-pane>
              <!--上架中  -->
              <el-tab-pane :label="$t('message.onTheShelf')" name="80"></el-tab-pane>
              <!--上架完了  -->
              <el-tab-pane :label="$t('message.storesUp')" name="90"></el-tab-pane>
              <!--  全部商品-->
              <el-tab-pane :label="$t('message.allGoods')" name="0"></el-tab-pane>
            </el-tabs>
            <!-- 不良码ID查询 -->
            <div class="bad-code-search">
              <el-input v-model.trim="badId" size="small" clearable
                :placeholder="$t('message.pleaseEnterBadId')" @keyup.enter.native="searchBadId">
              </el-input>
              <!-- 不良核查 -->
              <el-button type="primary" size="small" @click="searchBadId">
                {{ $t("message.badInspection") }}
              </el-button>
            </div>
            <!--配货工作状况  -->
            <el-button type="primary" class="primary picking-work-button" @click="pickingWork">
              {{ $t('message.pickingWorkStatus') }}
            </el-button>
          </div>
          <!-- 筛选 -->
          <div class="leftContainer">
            <div class="Container">
              <el-date-picker v-model="datas.dateStart" type="date" value-format="yyyy-MM-dd" size="small" clearable
                :placeholder="$t('message.startDate')">
              </el-date-picker>
            </div>
            <div class="Container">
              <el-date-picker v-model="datas.dateEnd" type="date" :placeholder="$t('message.dateClosed')"
                value-format="yyyy-MM-dd" size="small" clearable>
              </el-date-picker>
            </div>
            <!--请输入物流号 -->
            <div class="Container">
              <input type="text" v-model="datas.express_no" size="small" clearable onfocus="this.select()"
                @keyup.enter="inspect" :placeholder="$t('message.pleaseEnterLogisticsNumberOrBadId')">
              <i class="el-icon-circle-close close" v-if="datas.express_no" @click="datas.express_no = ''"></i>
            </div>
            <div class="Container">
              <!--请输入交易号 -->
              <div class="Container">
                <input type="text" v-model="datas.purchase_no" size="small" clearable onfocus="this.select()"
                  @keyup.enter="inspect" :placeholder="$t('message.pleaseEnterTransactionNumber')">
                <i class="el-icon-circle-close close" v-if="datas.purchase_no" @click="datas.purchase_no = ''"></i>
              </div>
            </div>
            <!--订单号 -->
            <div class="Container">
              <el-input v-model="datas.order_sn" size="small" clearable onfocus="this.select()"
                :placeholder="$t('message.orderNumber')"></el-input>
            </div>
            <!--订单号后5位 -->
            <div class="Container">
              <el-input v-model="datas.order_part" size="small" clearable onfocus="this.select()"
                :placeholder="$t('message.last5DigitsOfTheOrderNumber')"></el-input>
            </div>
            <!--商品管理编号 -->
            <div class="Container">
              <el-input v-model="datas.for_sn" size="small" clearable onfocus="this.select()"
                :placeholder="$t('message.productManagementNumber')"></el-input>
            </div>
          </div>
          <!-- 筛选 -->
          <div class="leftContainer" style="margin-top:20px">
            <!--客户ID -->
            <div class="Container">
              <el-input v-model="datas.user_id" size="small" clearable onfocus="this.select()"
                :placeholder="$t('message.clientID')"></el-input>
            </div>
            <!--订单号后5位 -->
            <div class="Container">
              <el-input v-model="datas.realname" size="small" clearable onfocus="this.select()"
                placeholder="客户真名模糊搜索"></el-input>
            </div>
            <!-- 采购 -->
            <div class="Container">
              <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')" size="small">
                <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 业务 -->
            <div class="Container">
              <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')" size="small">
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货员 -->
            <div class="Container">
              <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')"
                size="small">
                <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货员 -->
            <div class="Container">
              <el-select v-model="datas.attribute" clearable filterable placeholder="SVIP" size="small">
                <el-option :label="item.label" :value="item.value" v-for="(item) in vipList" :key="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="Container">
              <!-- 核查 -->
              <el-button type="primary" size="small" @click="inspect">{{
                $t("message.inspect")
              }}</el-button>
              <!-- 搜索 -->
              <el-button type="primary" size="small" @click="search">{{
                $t("message.filter")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footerContainer">
          <div class="table">
            <ol>
              <li class="flex05">NO</li>
              <!-- 选择 -->
              <li class="flex05">{{ $t("message.choose") }}</li>
              <!-- 番号 -->
              <li class="flex05">
                {{ $t("message.mash") }}
              </li>
              <!--  店铺信息-->
              <li class="flex15">
                {{ $t("message.storeInformation") }}
              </li>
              <!--照片-->
              <li>
                {{ $t("message.pic") }}
              </li>
              <!-- 业务编辑商品属性 -->
              <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
              <!--整番数量  -->
              <li>{{ $t("message.wholeRoundQuantity") }}</li>
              <!--交易号数量  -->
              <li class="flex2">{{ $t("message.numberOfTransactionNumbers") }}</li>
              <!-- 价格 -->
              <li>{{ $t("message.price") }}</li>
              <!-- 物流号 -->
              <li class="flex2">{{ $t("message.logisticsNumber") }}</li>
              <!--状态 -->
              <li>{{ $t("message.status") }}</li>
              <!-- 业务员商品备注 -->
              <li class="flex15">
                {{ $t("message.salesmanCommodityRemarks") }}
              </li>
              <!-- 业务跟单备注 -->
              <li class="flex15">
                {{ $t("message.businessFollowUpRemarks") }}
              </li>
              <!-- 采购商品备注 -->
              <li class="flex15">
                {{ $t("message.remarksForPurchasedCommodities") }}
              </li>
              <!-- 采购跟单备注 -->
              <li class="flex15">
                {{ $t("message.purchaseDocumentaryRemarks") }}
              </li>
              <!-- 配货商品备注 -->
              <li class="flex15">
                {{ $t("message.deliveryProductRemarks") }}
              </li>
              <!-- 操作 -->
              <li>{{ $t("message.operation") }}</li>
            </ol>
            <!-- 无数据显示 -->
            <div class="noData" v-if="tableData == false">暂无数据</div>
            <!-- 订单详情 -->
            <div class="detail" v-for="(item, index) in tableData" :key="index"
              :class="{ pay_over_three_days: item.pay_over_three_days && (datas.status == 3 || datas.status == 30) }">
              <div class="head">
                <!-- 全选 -->
                <div class="show">
                  <label>
                    <el-popover placement="right" title="合计" width="200" trigger="focus">
                      <statistics :selectList="checkedList" />
                      <el-checkbox v-model="item.checked" @change="changeOrder(index)" slot="reference"></el-checkbox>
                    </el-popover>
                  </label>
                </div>
                <!-- 是否显示 -->
                <div class="show" @click="isShow(index)">
                  <i class="el-icon-arrow-down" v-if="!item.show"></i>
                  <i class="el-icon-arrow-up" v-else></i>
                </div>
                <!--  付款时间 -->
                <div class="item transactionNumber">
                  <p>{{ $t("message.customerPaymentTime") }}</p>
                  <p>
                    {{ item.datetime_pay_confirm }}
                    <span style="color: #fa5058;font-weight: 600;">({{ item.pay_over_three_days }})天</span>
                  </p>
                </div>
                <!-- 订单号 -->
                <div class="item transactionNumber " style="flex: 1.8 !important;">
                  <div>
                    {{ item.user.realname }}
                    <div style="display: inline-block; width: 100px;vertical-align: middle;">
                      <attributeName :name="item.user_attribute" />
                    </div>
                  </div>
                  <p>
                    <router-link :to="'orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                      {{ item.order_sn }}
                      <span v-if="item.order_attribute == '付费会员'" style="color: #fa5058;">({{ item.order_attribute
                      }})</span>
                      <span v-else-if="item.order_attribute == 'SVIP'" style="color: rgb(247, 226, 3)">({{
                        item.order_attribute
                      }})</span>
                      <span v-else-if="item.order_attribute != ''">({{ item.order_attribute }})</span>
                    </router-link>
                    <!-- 供应商订单标识 -->
                    <span v-if="item.order_extend">
                      <el-tag size="mini" type="primary" class="primary" effect="dark"
                        v-if="item.order_extend.is_supplier_order">供应商订单</el-tag>
                    </span>
                  </p>
                </div>
                <!-- 交易号  -->
                <div class="item transactionNumber">
                  <p> {{ $t("message.transactionNumber") }}：</p>
                  <p>
                    <a :href="'https://trade.1688.com/order/new_step_order_detail.htm?orderId=' + item.purchase_no"
                      target="_blank" class="a-link"> {{ item.purchase_no }}</a>
                    <i class="el-icon-copy-document" @click="copy(item.purchase_no)"></i>
                  </p>
                </div>
                <div class="item name">
                  <!-- 业务 -->
                  <span>{{ $t("message.business") }}：{{ item.y_name }}</span>
                  <!--  采购-->
                  <span>{{ $t("message.purchase") }}：{{ item.g_name }}</span>
                  <!-- 配货 -->
                  <span>{{ $t("message.distribution") }}：{{ item.p_name }}</span>
                </div>
                <!-- 查看备注 -->
                <div class="lookRemark item">
                  <el-button type="primary" @click="lookRemark(item)" style="background: #fa5058" size="small">
                    RK{{ $t("message.orderNotes") }}</el-button>
                </div>
              </div>
              <!--  -->
              <ul v-for="(items, indexs) in item.list" :key="indexs" v-show="!item.show">
                <li class="flex05">
                  {{ indexs + 1 }}
                </li>
                <!-- 选择 -->
                <li class="flex05">
                  <label>
                    <el-popover placement="right" title="合计" width="200" trigger="focus">
                      <statistics :selectList="checkedList" />
                      <el-checkbox v-model="items.checked" @change="changeItem" slot="reference"></el-checkbox>
                    </el-popover>

                  </label>
                </li>
                <!-- 番号 -->
                <li class="flex05 wen">
                  {{ items.sorting }}
                  <!-- {{ items.problem_goods }} -->
                  <!-- <router-link
                    :to="'/pre-saleProblem?order_sn=' + item.order_sn + '&status=' + items.problem_goods[0].status"
                    target="_blank" v-if="items.problem_goods != false">问</router-link> -->
                  <el-popover placement="top-end" width="350" trigger="hover" v-if="items.problem_goods != false">
                    <div v-for="(problem_goods, problem_goodsIndex) in items.problem_goods" :key="problem_goodsIndex">
                      <p>问题提出时间：{{ problem_goods.created_at }}</p>
                      <p>问题类别：{{ problem_goods.type_name }}</p>
                      <p>具体问题描述：{{ problem_goods.description }}</p>
                    </div>
                    <router-link
                      :to="'/pre-saleProblem?order_sn=' + item.order_sn + '&status=' + items.problem_goods[items.problem_goods.length - 1].status"
                      target="_blank" slot="reference">问
                    </router-link>
                  </el-popover>
                </li>
                <!--  店铺信息-->
                <li class="flex15">
                  <div>
                    <p>{{ items.shop_name }}</p>
                    <p>{{ items.from_platform }}</p>
                    <p>{{ items.shop_id }}</p>
                  </div>
                </li>
                <!--照片-->
                <li>
                  <div>
                    <div class="btn">
                      <!-- 单番核查 -->
                      <p style="margin-bottom: 10px;">
                        <router-link
                          :to="`/inspectDetail?express_no=&purchase_no=${item.purchase_no}&order_detail_id=${items.order_detail_id}`"
                          target="_blank">
                          <el-button type="success" size="mini">{{ $t("message.singleCheck") }}</el-button>
                        </router-link>
                      </p>
                    </div>
                    <div class="img">
                      <el-popover placement="right" width="300" trigger="hover">
                        <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                        <a :href="items.link" target="_blank" slot="reference">
                          <img :src="items.pic" alt="" />
                        </a>
                      </el-popover>
                    </div>
                    <el-input size="mini" placeholder="管理番号" v-model="items.for_sn" style="padding: 0;"
                      @blur="batchUpdateOrderDetailForSn(items)" v-if="isAuth(579)"></el-input>
                    <p v-else>{{ items.for_sn }}</p>
                  </div>
                </li>
                <!-- 商品属性 -->
                <li class="flex15">
                  <div class="template">
                    <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                      <span>{{ skuItem.key }}:</span>
                      <span>{{ skuItem.value }}</span>
                    </p>
                  </div>
                </li>
                <!--整番数量  -->
                <li>
                  <div class="template">
                    <!-- 可入库 -->
                    <p>{{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num }}</p>
                    <!-- 已到货 -->
                    <p>{{ $t("message.itHasArrived") }}:{{ items.storage_num }}</p>
                    <!-- 已出货 -->
                    <p>{{ $t("message.shipped") }}:{{ items.delivery_num }}</p>
                  </div>
                </li>
                <!--交易号数量  -->
                <li class="flex2">
                  <div class="template" style="text-align: center;">
                    <p>交易号数量：{{ items.num }}</p>
                    <p>交易号已到货：{{ items.storage_num }}</p>
                    <p>交易号在库数：{{ items.stock_num }}</p>
                    <p>交易号已出货：{{ items.delivery_num }}</p>
                  </div>
                </li>
                <!-- 价格 -->
                <li>{{ items.confirm_price }}</li>
                <!-- 物流号 -->
                <li class="flex2">
                  <div>
                    <div v-for="express in items.order_purchase_express" :key="express.id"
                      @click="domesticLogisticsTracking(item.purchase_no, items.from_platform, express.express_no)">
                      <div>
                        <el-popover placement="left" title="国内物流:" width="400" trigger="click">
                          <el-timeline v-if="activities != false">
                            <el-timeline-item v-for="(activity, index) in activities" :key="index"
                              :timestamp="activity.time" :color="activity.color" placement="top">
                              {{ activity.address }}
                            </el-timeline-item>
                          </el-timeline>
                          <p v-else> 暂无物流信息 </p>
                          <p slot="reference">
                            <span class="WL">
                              <a href="javascript:;" class="a-link"> {{
                                express.express_no }}</a>
                              <i class="el-icon-copy-document" @click.stop="copy(express.express_no)"></i></span>
                          </p>
                        </el-popover>
                      </div>
                      <p>发货时间：{{ express.delivery_at }}</p>
                      <p>到货时间：{{ express.receive_at }}</p>
                    </div>
                    <p v-if="items.statusName == '检品完成' || items.statusName == '待检品'">送检时间：
                      {{ items.max_inspect_submit_at }}
                    </p>
                    <p v-if="items.statusName == '检品完成'">检品完成： {{ items.inspect_detail[0].inspect_at }}</p>
                  </div>
                </li>
                <!--状态 -->
                <li>
                  <div v-if="items.statusName == '检品完成'">
                    <span class="a-link" @click="lookInspect(items.inspect_detail)">
                      {{ items.statusName }}
                    </span>

                  </div>
                  <span v-else>{{ items.statusName }}</span>
                </li>
                <!-- 业务员商品备注 -->
                <li class="flex15">
                  <textarea v-model="items.y_remark" @blur="updateGoodsRemark(items, items.y_remark, 1, item.order_sn)"
                    @input="allEdit(items, items.y_remark, 'y_remark')" :disabled="remark_type != 1"></textarea>
                </li>
                <!-- 业务跟单备注 -->
                <li class="flex15">
                  <textarea v-model="items.order_detail_follow_remark.y_remark" @blur="updateFollowYRemark(items)"
                    :disabled="remark_type != 1"></textarea>
                </li>
                <!-- 采购商品备注 -->
                <li class="flex15">
                  <textarea v-model="items.g_remark"
                    @blur="updateGoodsRemark(items, items.g_remark, 2, item.order_sn, 'g_remark')"
                    @input="allEdit(items, items.g_remark, 'g_remark')" :disabled="remark_type != 2"></textarea>
                </li>
                <!-- 采购跟单备注 -->
                <li class="flex15">
                  <textarea v-model="items.order_detail_follow_remark.g_remark"
                    @blur="setUpProcurementTrackingNotes(items)" :disabled="remark_type != 2"></textarea>

                </li>
                <!-- 配货商品备注 -->
                <li class="flex15">
                  <textarea v-model="items.p_remark"
                    @blur="updateGoodsRemark(items, items.p_remark, 5, item.order_sn, 'p_remark')"
                    @input="allEdit(items, items.p_remark, 'p_remark')" :disabled="remark_type != 5"></textarea>
                  <!-- <el-input type="textarea" v-model="items.p_remark"
                    @blur="updateGoodsRemark(items, items.p_remark, 5, item.order_sn)"></el-input> -->
                </li>
                <!-- 操作 -->
                <li>
                  <div class="btn">
                    <!-- 同ID商品  -->
                    <p style="margin-bottom: 10px">
                      <el-button type="success" size="mini" @click="sameId(items.goods_id)">
                        {{ $t("message.productWithTheSameId") }}</el-button>
                    </p>
                    <!-- 同店铺商品 -->
                    <p style="margin-bottom: 10px">
                      <el-button type="success" size="mini" @click="sameShop(items.shop_id)">{{
                        $t("message.sameStoreProduct") }}</el-button>
                    </p>
                    <!-- 商品备注 -->
                    <p style="margin-bottom: 10px">
                      <el-button type="success" size="mini" class="primary" @click="remarkAll(items)">{{
                        $t("message.commodityNote") }}</el-button>
                    </p>
                    <!-- 退货打印 -->
                    <p v-if="item.user_id == 1868">
                      <el-button type="success" size="mini" class="primary" @click="label1868Print(item, items)">
                        退货打印
                      </el-button>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 操作 -->
          <div class="operation">
            <!-- 全选 -->
            <el-checkbox v-model="checked" @change="allChecked">{{
              $t("message.allChecked")
            }}</el-checkbox>
            <!-- <span @click="cancelAllChecked">
              {{ $t("message.cancelAllChecked") }}</span
            > -->
            <!-- 复制商品信息 -->
            <el-button type="primary" size="small" class="primary" @click="copyText">{{
              $t("message.copySelectedProductInformation") }}</el-button>
            <!-- 物流号添加 -->
            <el-button type="success" size="small" @click="addExpress">{{
              $t("message.logisticsNumberAdded")
            }}</el-button>
            <!-- 物流号修改 -->
            <el-button type="primary" size="small" class="primary" @click="updateExpress">{{
              $t("message.logisticsNumberModification") }}</el-button>
            <!-- 物流号删除 -->
            <el-button type="primary" size="small" class="dark" @click="deleteExpress">{{
              $t("message.logisticsNumberDeleted") }}</el-button>
            <!-- 批量添加备注 -->
            <el-button type="primary" size="small" class="primary" @click="batchAddRemarks">{{
              $t("message.batchAddRemarks") }}</el-button>
            <!-- 提出问题产品 -->
            <el-button type="primary" size="small" class="fr" @click="problemStore">{{ $t("message.questionProduct")
            }}</el-button>

            <!-- 提出复检单（精检） -->
            <el-button type="primary" size="small" class="fr"
              @click="submitTheReinspectionList($t('message.fineRetestList'), 'J')" v-if="isAuth(211)">{{
                $t("message.submitTheReinspectionListJ") }}</el-button>
            <!-- 提出复检单（普检） -->
            <el-button type="primary" size="small" class="fr"
              @click="submitTheReinspectionList($t('message.generalInspectionReinspectionList')), ''"
              v-if="isAuth(211)">{{ $t("message.submitTheReinspectionListP") }}
            </el-button>
          </div>
          <!-- 分页 -->
          <div class="paginationContainer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="datas.page" :page-sizes="[20, 50, 80, 100]" :page-size="datas.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </section>
    <!-- 查看备注 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="remarkDialogVisible" width="900px">
      <el-table :data="remarkData" style="width: 100%" border :header-cell-style="{ background: '#F0F0F0 ' }">
        <!-- 业务备注 -->
        <el-table-column :label="$t('message.serviceOrderRemarks')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.y_remark" onfocus="this.select()" type="textarea"
                :disabled="remark_type != 1"></el-input>
            </div>
            <p>{{ scope.row.y_last_updated_at }}</p>
          </template>
        </el-table-column>
        <!-- 采购备注 -->
        <el-table-column :label="$t('message.purchaseOrderRemarks')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.g_remark" onfocus="this.select()" type="textarea"
                :disabled="remark_type != 2"></el-input>
            </div>
            <p>{{ scope.row.g_last_updated_at }}</p>
          </template>
        </el-table-column>
        <!--  配货订单备注-->
        <el-table-column :label="$t('message.fulfillmentOrderNotes')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.p_remark" disabled onfocus="this.select()" type="textarea"
                :disabled="remark_type != 5"></el-input>
            </div>
            <p>{{ scope.row.p_last_updated_at }}</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="remarkDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <el-button type="primary" @click="updateSystemRemark">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 不良核查 -->
    <badInspection ref="badInspection" @confirmed="followList" />
    <!-- 问题产品 -->
    <problemStore />
    <!-- 商品备注  -->
    <commodityNote :data="itemData" v-if="commodityNoteDialogVisible" />
    <!-- 商品备注批量  -->
    <allCommodityNote :data="itemDatas" v-if="allCommodityNoteDialogVisible" />
    <!-- 物流号添加 -->
    <addExpress v-if="addExpressDialogVisible" :ids="selectedIDs" />
    <!-- 物流号删除 -->
    <deleteExpress v-if="deleteExpressDialogVisible" :expressList="expressList" :ids="selectedIDs" />
    <!-- 物流号修改 -->
    <updateExpress v-if="updateExpressDialogVisible" :expressList="expressList" :ids="selectedIDs" />
    <!-- 检品状态详情 -->
    <inspectDetail ref="inspectDetail" :tableData="inspectDetailList" />
    <!-- 配货工作状况 -->
    <pickingWorkStatus ref="pickingWorkStatus" />
    <!-- 退货打印 -->
    <returnLabel ref="returnLabel" />
    <!-- 复捡单 -->
    <listOfReinspection v-if="reinspectionDialogVisible" :list="reinspectionList" :type="reinspectionType" />
  </div>
</template>
<script>
import problemStore from "@/components/problemStore/store/index.vue";
import commodityNote from "../components/commodityNote";
import allCommodityNote from "../components/allCommodityNote";
import addExpress from "@/views/orderDetail/components/addExpress";
import deleteExpress from "@/views/orderDetail/components/deleteExpress";
import updateExpress from "@/views/orderDetail/components/updateExpress";
import inspectDetail from '@/components/box/inspectDetail'
import pickingWorkStatus from '../components/pickingWorkStatus'
import statistics from '../components/statistics'
import returnLabel from '../../../inspectDetail/components/returnLabel'
import listOfReinspection from "../components/listOfReinspection";
import badInspection from './components/badInspection.vue'
import { vipList } from '@/utlis/options'
export default {
  components: {
    problemStore,
    commodityNote,
    addExpress,
    deleteExpress,
    updateExpress,
    allCommodityNote,
    inspectDetail,
    pickingWorkStatus,
    statistics,
    returnLabel,
    listOfReinspection,
    badInspection,
  },
  data() {
    return {
      vipList,
      datas: {
        page: 1,
        pageSize: 20,
        status: this.$route.query.state ? this.$route.query.state : "3",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        order_sn: "",
        express_no: "",
        purchase_no: "",
        order_sn: "",
        order_part: "",
        realname: '',
      },
      tableData: [],
      total: 0,
      val: "",
      type: "",
      time: [],
      checked: false,
      badId: '',
      checkedList: [], //选中的商品
      typeOptions: [
        {
          label: this.$t("message.userID"),
          value: "1",
        },
        {
          label: this.$t("message.orderNumber"),
          value: "2",
        },
      ],
      remarkData: [],
      remarkDialogVisible: false, // 查看备注
      commodityNoteDialogVisible: false, // 商品备注
      allCommodityNoteDialogVisible: false,//批量修改商品备注
      itemData: {}, //单番商品
      itemDatas: {}, //批量修改
      problemList: [],
      addExpressDialogVisible: false, //物流号添加
      deleteExpressDialogVisible: false, //物流号删除
      updateExpressDialogVisible: false, //修改物流号
      expressList: [],
      selectedList: [],
      selectedIDs: [],
      remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
      activities: [],
      inspectDetailList: [],//检品详情
      reinspectionList: [],//复捡单列表
      reinspectionType: '',//复捡单类型
      reinspectionDialogVisible: false,//复捡单弹窗显示
      p: [], // 配货员列表
    };
  },

  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
  },
  created() {
    this.getDepartmentDistributors();
    this.followList();
  },

  methods: {
    // 获取部门配货员列表
    getDepartmentDistributors() {
      this.$api.getDepartmentDistributors().then(res => {
        this.p = Array.isArray(res.data) ? res.data : []
      })
    },
    // 获取列表
    followList() {
      this.$api.inspectionApi.followList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.checked = false
          item.list.forEach((items) => {
            items.checked = false;
          });
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    //搜索
    search() {
      this.datas.page = 1;
      this.followList();
    },
    // 按不良码ID打开不良核查
    searchBadId() {
      if (!this.badId) {
        return this.$message.error(this.$t("message.pleaseEnterBadId"));
      }
      this.$refs.badInspection.openById(this.badId);
    },    // 核查
    inspect() {
      const expressNo = String(this.datas.express_no || '').trim()
      // BL 开头的是不良码，去掉前缀后按不良码ID进入现有不良核查流程。
      if (/^BL/i.test(expressNo)) {
        const badId = expressNo.replace(/^BL-?/i, '')
        if (!badId) return this.$message.error(this.$t('message.pleaseEnterBadId'))
        this.$refs.badInspection.openById(badId)
        return
      }
      if (this.datas.express_no == "" && this.datas.purchase_no == "") {
        return this.$message.error(
          this.$t(
            "message.pleaseEnterTheLogisticsNumberAndTransactionNumberBeforeChecking"
          )
        );
      }
      let routeUrl = this.$router.resolve({
        path:
          "/inspectDetail?express_no=" +
          this.datas.express_no +
          "&purchase_no=" +
          this.datas.purchase_no,
      });
      window.open(routeUrl.href, "_blank");
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.followList();
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.followList();
    },
    // 是否显示商品列表
    isShow(i) {
      this.tableData[i].show = !this.tableData[i].show;
      this.$forceUpdate();
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //订单全选
    changeOrder(i) {
      this.checkedList = [];

      this.tableData[i].list.forEach((items) => {
        items.checked = this.tableData[i].checked;
      })
      this.$forceUpdate();
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
        })
      });
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.checked = this.checked;
        item.list.forEach((items) => {
          items.checked = this.checked;
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //取消全选
    cancelAllChecked() {
      this.checkedList = [];
      this.checked = false;
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = false;
        });
      });
      this.$forceUpdate();
    },
    // 查看备注
    lookRemark(item) {
      if (item.order_remark == false || item.order_remark == null) {
        item.order_remark = {
          g_last_updated_at: null,
          g_remark: "",
          order_sn: item.order_sn,
          p_last_updated_at: null,
          p_remark: "",
          y_last_updated_at: "",
          y_remark: "",
        };
      } else {
        item.order_remark.order_sn = item.order_sn
      }
      this.remarkData = [];
      this.remarkData.push(item.order_remark);
      this.remarkDialogVisible = true;
    },
    // 提出问题产品
    problemStore() {
      let datas = {
        order_purchase_id: [],
        order_detail_id: [],
        inspect_detail_id: [],
        status: [],
      };
      let order_sn = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            datas.order_purchase_id.push(items.order_purchase_id);
            datas.order_detail_id.push(items.order_detail_id);
            order_sn.push(item.order_sn);
          }
        });
      });
      //
      if (datas.order_purchase_id == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      order_sn = Array.from(new Set(order_sn));
      // 问题产品提出需要限制单次只能单个订单的商品一起提出问题产品
      if (order_sn.length > 1)
        return this.$message.error(this.$t("message.danGeDanDingDan"));
      this.$store.dispatch("getProblemList", datas);
      this.checked = false;
      this.allChecked();
    },
    // 同店铺商品
    sameShop(shop_id) {
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.shop_id == shop_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 同ID商品
    sameId(goods_id) {
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.goods_id == goods_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 订单采购编辑
    updateSystemRemark() {
      let datas = {
        order_sn: this.remarkData[0].order_sn,
        remark_type: this.remark_type,
        remark: '',
      };
      if (this.remark_type == 1) {
        datas.remark = this.remarkData[0].y_remark
      } else if (this.remark_type == 2) {
        datas.remark = this.remarkData[0].g_remark
      } else if (this.remark_type == 5) {
        datas.remark = this.remarkData[0].p_remark
      }
      this.$api.orderApi.updateRemark(datas).then((res) => {
        this.$message.success(res.msg);
        this.remarkDialogVisible = false;
        this.followList();
      });
    },
    //商品备注
    remarkAll(item) {
      this.itemData = item;
      this.commodityNoteDialogVisible = true;
    },
    //更新备注
    uploadRemark() {
      this.commodityNoteDialogVisible = false;
      this.allCommodityNoteDialogVisible = false;
      this.followList();
    },
    // 选中的商品id
    selected() {
      this.selectedList = [];
      this.selectedIDs = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            items.purchase_no = item.purchase_no;
            this.selectedList.push(items);
            this.selectedIDs.push(items.order_purchase_id);
          }
        });
      });
      this.$forceUpdate();
    },
    //物流号添加
    addExpress() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.addExpressDialogVisible = true;
    },
    //物流号删除
    deleteExpress() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.expressList = this.getSelectedExpressList();
      if (this.expressList == false)
        return this.$message.error("无可以删除的物流号");
      this.deleteExpressDialogVisible = true;
    },
    // 物流修改
    updateExpress() {
      this.selected();
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.expressList = this.getSelectedExpressList();
      if (this.expressList == false)
        return this.$message.error("无可以修改的物流号");
      this.updateExpressDialogVisible = true;
    },
    getSelectedExpressList() {
      let expressList = [];
      this.selectedList.forEach((item) => {
        if (Array.isArray(item.order_purchase_express) && item.order_purchase_express.length > 0) {
          item.order_purchase_express.forEach((express) => {
            expressList.push({
              ...express,
              order_purchase_id: item.order_purchase_id,
              purchase_no: item.purchase_no,
            });
          });
        }
      });
      return expressList;
    },
    // 物流号操作成功
    wuliuSuccess() {
      this.addExpressDialogVisible = false; //物流号添加
      this.deleteExpressDialogVisible = false; //物流号删除
      this.updateExpressDialogVisible = false; //修改物流号
      this.checked = false
      this.followList();
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.followList();
      this.$refs.badInspection.close();
    },
    // 批量商品备注
    batchAddRemarks() {
      this.itemDatas = {
        order_detail_id: []
      }
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.itemDatas.order_detail_id.push(items.order_detail_id)
          }
        });
      });
      this.allCommodityNoteDialogVisible = true
    },
    //复制选择商品信息
    copyText() {
      let list = []
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            items.order_sn = item.order_sn
            items.purchase_no = item.purchase_no
            list.push(items)
          }
        });
      });
      if (list.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      list.forEach((item) => {
        if (this.remark_type == 2) {
          let size = ''
          item.detail_y.forEach(items => {
            size += `${items.key}:${items.value} `
          })
          copyUrl += `${size}\n数量${item.num}\n订单番号:${item.order_sn}\n商品番号:${item.sorting}\n链接:${item.link}\n交易号: ${item.purchase_no}\n`
        } else {
          copyUrl += `${item.order_sn}\n${item.sorting}番  ${item.link}\n交易号: ${item.purchase_no}\n`
        }
      });
      this.copy(copyUrl)

    },
    //同步修改
    allEdit(data, value, remarkType) {
      if (data.checked) {
        this.tableData.forEach(items => {
          items.list.forEach(itemss => {
            if (itemss.checked) {

              itemss[remarkType] = value
            }
          })
        })
      }
    },
    //修改备注
    updateGoodsRemark(item, remark, type, order_sn,) {
      let datas = {
        order_sn: order_sn,
        remark,
        order_detail_id_set: [],
        remark_type: type
      }
      if (item.checked) {
        this.tableData.forEach(items => {
          items.list.forEach(itemss => {
            if (itemss.checked) {
              datas.order_detail_id_set.push(itemss.order_detail_id)
            }
          })
        })
      } else {
        datas.order_detail_id_set = [item.order_detail_id]
      }
      this.$api.orderApi.updateGoodsRemark(datas)
    },
    // 跟单备注
    updateFollowYRemark(data) {
      let datas = {
        y_remark: data.order_detail_follow_remark.y_remark,
        order_detail_id_set: []
      }
      //当前勾选的全部勾选修改
      if (data.checked) {
        this.tableData.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              datas.order_detail_id_set.push(items.order_detail_id)
            }
          })
        })
      } else { // 没有勾选的当单修改
        datas.order_detail_id_set = [data.order_detail_id]
      }
      this.$api.orderApi
        .updateFollowYRemark(datas)
        .then((res) => {
          // 不刷新页面直接填充
          this.tableData.forEach(item => {
            item.list.forEach(items => {
              datas.order_detail_id_set.forEach(orderId => {
                if (items.order_detail_id == orderId) {
                  items.order_detail_follow_remark.y_remark = data.order_detail_follow_remark.y_remark
                }
              })

            })
          })
          this.$forceUpdate()
        });
    },
    //获取国内物流轨迹
    domesticLogisticsTracking(purchase_no, from_platform, express_no) {
      let datas = {
        purchase_no,
        from_platform,
        express_no
      }
      this.activities = []
      this.$api.domesticLogisticsTracking(datas).then(res => {
        if (res.data.all_adress != false) {
          res.data.all_adress[0].color = '#B4272D'
        }
        this.activities = res.data.all_adress
      })

    },
    //查看检品详情
    lookInspect(inspectDetailList) {
      this.inspectDetailList = inspectDetailList
      this.$refs.inspectDetail.dialogVisible = true
    },
    // 设置采购跟单备注
    setUpProcurementTrackingNotes(data) {
      let datas = {
        g_remark: data.order_detail_follow_remark.g_remark,
        order_detail_id_set: []
      }
      //当前勾选的全部勾选修改
      if (data.checked) {
        this.tableData.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              datas.order_detail_id_set.push(items.order_detail_id)
            }
          })
        })
      } else { // 没有勾选的当单修改
        datas.order_detail_id_set = [data.order_detail_id]
      }
      this.$api.orderApi
        .updateFollowGRemark(datas)
        .then((res) => {
          // 不刷新页面直接填充
          this.tableData.forEach(item => {
            item.list.forEach(items => {
              datas.order_detail_id_set.forEach(orderId => {
                if (items.order_detail_id == orderId) {
                  items.order_detail_follow_remark.g_remark = data.order_detail_follow_remark.g_remark
                }
              })

            })
          })
          this.$forceUpdate()
        });
    },
    // 配货工作状况
    pickingWork() {
      this.$refs.pickingWorkStatus.dialogVisible = true
      this.$refs.pickingWorkStatus.date = ''
      this.$refs.pickingWorkStatus.tableData = []
    },
    // 1868标签打印
    label1868Print(item, items,) {
      let labelData = {
        sorting: items.sorting,
        detail_y: items.detail_y,
        order_sn: item.order_sn,
        order_detail_tag: items.order_detail_tag != false ? items.order_detail_tag[0] : '',
        confirm_num: items.confirm_num,
        inspectNum: '',
        type: '',
        g_name: item.g_name,
        p_name: item.p_name,
        y_name: item.y_name,
        user_name: item.user.realname,
        purchase_no: item.purchase_no,
        order_purchase_express: items.order_purchase_express != null ? items.order_purchase_express[0].express_no : '',
      }
      if (labelData.order_detail_tag == '') {
        return this.$message.error(
          '请选择有标的商品'
        );
      }
      // 取detail_y的第一个值
      let type = items.detail_y != false ? items.detail_y[0].value : ''
      if (type.includes('／')) {
        labelData.type = type.split('／')[0]
      }
      // 没有检测类型时，取detail_y的第一个值
      if (labelData.type == '') {
        type = items.detail_y != false ? items.detail_y[1].value : ''
        if (type.includes('／')) {
          labelData.type = type.split('／')[0]
        }
      }

      this.$refs.returnLabel.labelData = labelData
      this.$refs.returnLabel.dialogVisible = true

    },
    // 提出复检单
    submitTheReinspectionList(title, type) {
      this.reinspectionList = [];
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));

      //创建提交数据
      this.tableData.forEach((item) => {
        let flag = item.list.some((items) => items.checked);
        if (flag) {
          let itemsData = JSON.parse(JSON.stringify(item));
          itemsData.inspect_detail = [];
          itemsData.order_time_node = { datetime_pay_confirm: item.datetime_pay_confirm }
          itemsData.y_admin = { realname: item.y_name }
          itemsData.p_admin = { realname: item.p_name }
          itemsData.g_admin = { realname: item.g_name }
          item.list.forEach((items) => {
            if (items.checked) {
              items.order_sn = item.order_sn
              let data = {
                reinspection_num: items.possible_num - items.storage_num,
                order_purchase: {
                  possible_num: items.possible_num,
                  storage_num: items.storage_num,

                  order_detail: JSON.parse(JSON.stringify(items))
                }
              }
              itemsData.inspect_detail.push(data);
            }
          });
          this.reinspectionList.push(itemsData);
        }

      });
      this.reinspectionType = title;
      this.reinspectionDialogVisible = true;
    },
    //订单-修改管理番号
    batchUpdateOrderDetailForSn(item) {
      let datas = {
        order_detail_id_set: [item.order_detail_id],
        for_sn: item.for_sn
      }
      this.$api.orderApi.batchUpdateOrderDetailForSn(datas)
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin";

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }
}

section {
  position: relative;

  .header {
    padding: 0;
  }

  .headerContainer {
    background-color: #f6f6f6 !important;
    padding: 0 !important;

    .tabs {
      position: relative;

      .picking-work-button {
        position: absolute;
        top: 0;
        right: 0;
      }

      .bad-code-search {
        position: absolute;
        top: 0;
        right: 260px;
        display: flex;
        width: 315px;

        .el-button {
          margin-left: 8px;
        }
      }
    }
  }

  .footer {
    padding: 0;
    background-color: #f6f6f6 !important;

    .footerContainer {
      padding: 0;
    }
  }
}

.leftContainer {
  width: 100% !important;
  display: flex;

  input {
    width: 188px;
    height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 0 5px;

  }

  .Container {
    width: 200px;
    margin-right: 20px;
    position: relative;

    .close {
      position: absolute;
      right: 10px;
      top: 8px;
      cursor: pointer;
      color: #C0C4CC;

    }

    /deep/.el-date-editor {
      width: 100%;
    }
  }

  .time {
    margin-right: 20px;
  }
}

.table {
  margin-top: 24px;

  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin-bottom: 20px;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;
      }

      .btn {
        width: 100%;

        .el-button {
          width: 70px;
          padding: 5px;
        }
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }


    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .flex-transaction {
    flex: 2.5;
  }

  .transaction-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    font-size: 12px;
  }

  .detail {
    .head {
      height: 60px;
      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      a {
        color: #f0ef70;
      }

      .show {
        flex: 0.3;
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 16px;
        }
      }

      .item {
        flex: 1;
        line-height: 20px;
        padding: 10px;

        span {
          margin-right: 30px;
          word-break: keep-all;
          /* 不换行 */
          white-space: nowrap;
          /* 不换行 */
          overflow: hidden;
          /* 内容超出宽度时隐藏超出部分的内容 */
          text-overflow: ellipsis;
        }
      }

      .order {
        flex: 3;
      }

      .name {
        flex: 2.5;
        line-height: 40px;
      }

      .lookRemark {
        text-align: right;
        line-height: 40px;
        margin-right: 14px;
      }

      .transactionNumber {


        flex: 1.5 !important;
      }


    }

    textarea {
      height: 100px;
      width: 98%;
      border: 1px solid #DCDFE6;
      padding: 2px;
      border-radius: 4px;
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

.operation {
  background-color: #edeff4;
  padding: 16px 24px;
  position: sticky;
  bottom: 0;
  z-index: 9;

  .el-button {
    margin-left: 30px;
  }

  span {
    margin-left: 30px;
    font-size: 14px;
    cursor: pointer;
  }
}

/deep/ .el-textarea__inner {
  height: 80px;
  padding: 0 2px;
  line-height: 18px;
}

.pay_over_three_days {
  background-color: #da9396 !important;
}
</style>
